var map = {
	"./gallery-wip-denix-scope-mount-hole_00.jpg": 2860,
	"./gallery-wip-denix-scope-mount-hole_01.jpg": 2861,
	"./gallery-wip-denix-scope-mount-hole_02.jpg": 2862,
	"./gallery-wip-denix-scope-mount-hole_03.jpg": 2863,
	"./gallery-wip-denix-scope-mount-hole_04.jpg": 2864,
	"./gallery-wip-denix-scope-mount-hole_05.jpg": 2865,
	"./gallery_00.jpg": 2866,
	"./gallery_01.jpg": 2867,
	"./gallery_02.jpg": 2868,
	"./gallery_03.jpg": 2869,
	"./gallery_04.jpg": 2870,
	"./gallery_05.jpg": 2871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2859;